import { Stack } from '@/components/layout';
import { useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';

const separatorLineStyle = StyleSheet.create({
  line: {
    width: '93%',
    height: StyleSheet.hairlineWidth,
    backgroundColor: colors['6'],
  },
}).line;

/**
 * Default list item separator — hairline on phone, fixed gap on tablet.
 */
export const Separator = memo(function SeparatorComponent() {
  const { scale, isTablet } = useScaling();

  if (isTablet) {
    return <View style={{ height: scale(12) }} />;
  }

  return (
    <Stack
      height={scale(24)}
      paddingX={scale({ phone: 18, tablet: 0 })}
      align="center"
      justify="center">
      <View style={separatorLineStyle} />
    </Stack>
  );
});
Separator.displayName = 'PlayerListTemplateV2.Separator';
